import * as yup from 'yup';
import { EMAIL_VALIDATION_REGEXP } from '@lon/shared/constants';
import { getValidationMessages } from './getValidationMessages';

declare module 'yup' {
  interface StringSchema {
    noSpaces(errorMessage?: string): StringSchema;

    strongEmail(): StringSchema;

    toNull(): StringSchema;

    containSymbols(): StringSchema;
  }

  interface MixedSchema {
    noInvalidChars(chars: string[], message?: string): MixedSchema;

    maxSize(size: number, message?: string): MixedSchema;

    mimeType(allowed: string | string[], message?: string): MixedSchema;
  }
}

yup.addMethod<yup.StringSchema>(
  yup.string,
  'noSpaces',
  function (this: yup.StringSchema, errorMessage) {
    return this.test(
      'no-spaces',
      errorMessage || 'Field cannot contain spaces',
      function (value) {
        if (!value) return true; // Skip validation if value is null or undefined
        return /^\S+$/u.test(value); // Return true if value does not contain any whitespace character
      }
    );
  }
);
yup.addMethod<yup.StringSchema>(
  yup.string,
  'strongEmail',
  function (this: yup.StringSchema) {
    return this.test('strong-email', getValidationMessages().email, (value) => {
      if (!value) {
        return true;
      }
      return EMAIL_VALIDATION_REGEXP.test(value);
    });
  }
);
yup.addMethod<yup.StringSchema>(yup.string, 'toNull', function () {
  return this.transform((value) => (value === '' ? null : value));
});

//@ts-ignore
yup.addMethod<yup.MixedSchema>(
  yup.mixed,
  'noInvalidChars',
  function (chars: string[], message?: string) {
    //@ts-ignore
    return this.test(
      'no-invalid-chars',
      message || `The file name must not contain ${chars.join(', ')}`,
      //@ts-ignore
      function (value) {
        //@ts-ignore
        const { path, createError } = this;

        if (!value || !(value instanceof Blob)) {
          return true;
        }

        const fileName = value.name;

        if (chars.some((char) => fileName.includes(char))) {
          return createError({
            path,
            message:
              message || `The file name must not contain ${chars.join(', ')}`,
          });
        }

        return true;
      }
    );
  }
);

//@ts-ignore
yup.addMethod<yup.MixedSchema>(
  yup.mixed,
  'maxSize',
  function (size: number, message?: string) {
    //@ts-ignore
    return this.test(
      'no-invalid-chars',
      message || `Max file size is ${size} MB.`,
      function (value: string | Blob) {
        //@ts-ignore
        const { path, createError } = this;

        if (!value || !(value instanceof Blob)) {
          return true;
        }

        const fileSize = value.size;

        if (size ? fileSize > size * 1024 * 1024 : false) {
          return createError({
            path,
            message: message || `Max file size is ${size} MB.`,
          });
        }

        return true;
      }
    );
  }
);

//@ts-ignore
yup.addMethod<yup.MixedSchema<File | Blob | undefined>>(
  yup.mixed,
  'mimeType',
  function (allowedTypes: string | string[], message?: string) {
    return this.test(
      'mime-type',
      message || 'Unavailable file type',
      function (value: string | Blob) {
        //@ts-ignore
        const { path, createError } = this;
        if (!value || !(value instanceof Blob)) return true; // пропускаем проверку, если значение пустое

        const allowed = Array.isArray(allowedTypes)
          ? allowedTypes
          : [allowedTypes];
        return allowed.includes(value.type) || createError({ path, message });
      }
    );
  }
);

export { yup };
